import React from "react";

export default {
  'DateInput.Wrapper.MonthWrapper.Input(Keydown)': ({ }) => {
  },
  'DateInput.Wrapper.MonthWrapper.Input': async ({ value, day, year, dayInputRef, disablePastDates }, outlet, internalStateSetter) => {
    let val = value;

    let ref = dayInputRef;
    if (!dayInputRef) {
      ref = React.createRef();
      await internalStateSetter({ dayInputRef: ref })
    }

    if (/^\d{1,2}$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (numValue < 0 || numValue > 12) {
        val = '';
      } else if (value.length === 1 && value !== '0' && value !== '1') {
        val = '0' + value;
      }
    } else {
      val = '';
    }

    if (val.length === 2) {
      ref?.current?.children[0]?.focus();
    }

    internalStateSetter({ month: val });

    if (!!val && !!day && year.length === 4) {
      const updatedDate = new Date(parseInt(year), parseInt(val) - 1, parseInt(day));
      if(checkValidDate(updatedDate, disablePastDates)) {
        outlet({ selectedDate:  updatedDate});
        internalStateSetter({ invalidDate: false });
      } else {
        internalStateSetter({ invalidDate: true });
      }
    }
  },
  'DateInput.Wrapper.DayWrapper.Input(Keydown)': async ({ value, key, monthInputRef, yearInputRef }, outlet, internalStateSetter) => {

    let monthRef = monthInputRef;
    let yearRef = yearInputRef;
    if (!monthInputRef || !yearInputRef) {
      monthRef = React.createRef();
      yearRef = React.createRef();
      await internalStateSetter({ monthInputRef: monthRef, yearInputRef: yearRef })
    }

    if (key === 'Backspace' && value === '') {
      monthInputRef?.current?.children[0]?.focus();
    }
  },
  'DateInput.Wrapper.DayWrapper.Input': async ({ value, month, year, monthInputRef, yearInputRef, disablePastDates }, outlet, internalStateSetter) => {
    let val = value;

    if (/^\d{1,2}$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (numValue < 0 || numValue > 31) {
        val = '';
      } else if (value.length === 1 && numValue > 3) {
        val = '0' + value;
      }
    } else {
      val = '';
    }

    let monthRef = monthInputRef;
    let yearRef = yearInputRef;
    if (!monthInputRef || !yearInputRef) {
      monthRef = React.createRef();
      yearRef = React.createRef();
      await internalStateSetter({ monthInputRef: monthRef, yearInputRef: yearRef })
    }

    if (val.length === 2) {
      yearRef?.current?.children[0]?.focus();
    }

    internalStateSetter({ day: val });

    if (!!val && !!month && year.length === 4) {
      const updatedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(val));
      if(checkValidDate(updatedDate, disablePastDates)) {
        outlet({ selectedDate:  updatedDate});
        internalStateSetter({ invalidDate: false });
      } else {
        internalStateSetter({ invalidDate: true });
      }
    }
  },

  'DateInput.Wrapper.YearWrapper.Input(Keydown)': async ({ value, key, dayInputRef }, _, internalStateSetter) => {

    let ref = dayInputRef;
    if (!dayInputRef) {
      ref = React.createRef();
      await internalStateSetter({ dayInputRef: ref })
    }

    if (key === 'Backspace' && value === '') {
      dayInputRef?.current?.children[0]?.focus();
    }
  },
  'DateInput.Wrapper.YearWrapper.Input': async ({ value, month, day, disablePastDates }, outlet, internalStateSetter) => {
    let val = value;

    if (/^\d{1,4}$/.test(value)) {
        val = value;
    } else {
      val = '';
    }

    internalStateSetter({ year: val });
    if (val.length === 4 && !!month && !!day) {
      const updatedDate = new Date(parseInt(val), parseInt(month) - 1, parseInt(day));
      if(checkValidDate(updatedDate, disablePastDates)) {
        outlet({ selectedDate:  updatedDate});
        internalStateSetter({ invalidDate: false });
      } else {
        internalStateSetter({ invalidDate: true });
      }
    }
  },
}

function checkValidDate(date, disablePastDates = false) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (disablePastDates && date < today) {
    return false;
  }
  return true;
}



